import React from 'react';
import Nav from './components/Nav';
import Hero from './components/Hero';
import AnimationEmbed from './components/AnimationEmbed';
import SocialProof from './components/SocialProof';
import DashboardPreview from './components/DashboardPreview';
import Solutions from './components/Solutions';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';

/*
  Conversion Funnel (Optimized):
  1. AWARENESS  — Hero: bold claim, primary CTA
  2. EDUCATION  — How It Works: interactive carousel demo with step descriptions
  3. PROOF      — Social Proof: deployment stats & environments
  4. DESIRE     — Dashboard Preview: tangible product + live CTA
  5. EVALUATION — Solutions: product tiers + deployment options
  6. TRUST      — Privacy Strip + FAQ: objection handling
  7. ACTION     — Contact: form + details
*/

export default function App() {
  return (
    <>
      <div className="global-grid" />
      <Nav />
      <Hero />
      <AnimationEmbed />
      <div className="divider" />
      <SocialProof />
      <div className="divider" />
      <DashboardPreview />
      <div className="divider" />
      <Solutions />
      <FAQ />
      <Contact />
      <Footer />
    </>
  );
}
